import { get, post } from "./request";

// 试用申请相关API
export const trialApi = {
  // 提交试用申请
  submitTrial: (data) => {
    return post("/idatausa-service/api/auth/register", data)
  }
}

// 用户相关API
export const userApi = {
  // 用户登录
  login: (credentials) => {
    return post("/idatausa-service/api/auth/login", credentials)
  },

  // 用户登出
  logout: () => {
    return post("/idatausa-service/api/auth/logout")
  },

  // 忘记密码发送验证码
  sendCode: (data) => {
    return post("/idatausa-service/api/auth/forgot-password/send-code", data)
  },

  // 重置密码
  updatePassword: (data) => {
    return post("/idatausa-service/api/auth/forgot-password/reset", data)
  },

  // 检查用户登录状态
  checkLoginStatus: () => {
    return get("/idatausa-service/api/products/check")
  },
}

// 产品相关API
export const productApi = {
  // 获取产品列表
  getProductList: (data) => {
    return get("/idatausa-service/api/products/get", data)
  },
}
